import { LOGIN_API_URL } from '@constants/config';

const keycloakHost = LOGIN_API_URL;
const realmName = 'etd-realm';
const redirectUrl = window.location.origin;

export const loginLink = `${keycloakHost}auth/realms/${realmName}/protocol/openid-connect/auth?response_type=code&client_id=${process.env.REACT_APP_LOGIN_CLIENT_ID}&scope=openid&redirect_uri=${redirectUrl}`;
export const logoutLink = `${keycloakHost}auth/realms/${realmName}/protocol/openid-connect/logout?redirect_uri=${redirectUrl}`;
